import keyMirror from "keymirror";

export default keyMirror({
  SET_SPONSOR_STATISTIC: null,
  SET_SPONSOR_STATISTIC_SUCCESS: null,
  SET_SPONSOR_STATISTIC_ERROR: null,
});
